import { EventCard } from "../../EventCard";
import * as RenderMethods from "./RenderMethods";

export class Regular extends EventCard {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.cardTypeClass = "rj-ev-list__ev-card--regular";
        this.buttonsHolderClass = "rj-ev-list__ev-card__buttons-holder--regular";
    }

    renderMarkets = RenderMethods.renderMarketsRegular;
    renderBetButtons = RenderMethods.renderBetButtonsRegular;
}